let _cachedResponse: boolean = undefined;

const WEBP_BLACKLIST: string[] = [
    'resource/graphics/particles',
    'resource/graphics/shares',
    'resource/graphics/level_backgrounds',
    'resource/graphics/other',
    'resource/graphics/messages',

    // This file gets 200kb bigger due to strong transparency effects
    // so we'll just load the png.
    // todo: come up with better system than a blacklist
    'resource/graphics/sprite_sheets/LuckyTurnips',
];

export function isWebPSupported(): boolean {
    if (typeof _cachedResponse !== 'undefined') return _cachedResponse;
    try {
        let canvas: HTMLCanvasElement = document.createElement('canvas');
        const dataUrl: string = canvas.toDataURL('image/webp');
        canvas = null; // explicit clear
        _cachedResponse = dataUrl.indexOf('data:image/webp') == 0;
        if (_cachedResponse) console.log('WebP supported');
        return _cachedResponse;
    } catch (err) {
        // we don't care
        console.log('WebP unsupported');
        return false;
    }
}

export function shouldLoadAsWebP(
    resource?: PIXI.loaders.Resource | null,
    optExtension?: string,
    optName?: string,
    optUrl?: string
): boolean {
    return (
        // is PNG
        (resource?.extension || optExtension) === 'png' &&
        // is an image from PIXI loader
        (((resource?.name || optName).indexOf('_image') >= 0 &&
            (resource?.name || optName).indexOf('_image') === (resource?.name || optName).length - '_image'.length) ||
            (optUrl && optUrl.indexOf('/dragonbones/') !== -1)) &&
        // is not on the blacklist
        WEBP_BLACKLIST.findIndex(e => (resource?.url || optUrl).indexOf(e) !== -1) === -1
    );
}
